import * as Styled from './styles'
import nextLevelInterviewPrepImage from './images/next-level-interview-prep.png'

export const InterviewPrepPreview = () => {
  return <Styled.Image src={nextLevelInterviewPrepImage} alt="Interview Prep" />
}
